import React from 'react';
import logomasjid from '../src/image/logomasjid.png'
// import { Link } from 'react-router-dom';
// import './Login.css'; // Impor file CSS untuk gaya tambahan

function Home() {
    const descriptionStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '90vh',
        width:'35vh',
        // backgroundColor:'white'
    };
  return (
    <div className="" style={descriptionStyle}>
        <img src={logomasjid} alt="Logo" />
        <p style={{ fontSize:30, fontFamily:'cursive' }}>Tracking Qurban</p>
    </div>
  );
}

export default Home;
